import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {testIdProps} from '@github-ui/test-id-props'

import {RunnerList} from './RunnerList'
import styles from './SkeletonList.module.css'

export function SkeletonList({listTitle}: {listTitle: string}) {
  return (
    <RunnerList isLoading listTitle={listTitle} numberOfRunners={0} {...testIdProps('skeleton-list')}>
      <div className={styles.skeletonContainer}>
        <LoadingSkeleton width="150px" />
        <LoadingSkeleton width="350px" />
      </div>
    </RunnerList>
  )
}
